import { Stack } from 'expo-router';
import React from 'react';

function BorrowingPowerLayout() {
  return <Stack />;
}

export default BorrowingPowerLayout;
